import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-label uppercase tracking-widest text-accent-600">
            <span className="h-px w-6 bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-500">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-label text-primary-500 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}